module.exports = {
    apiUrl: process.env.BACKEND_API_URL,
    newApiUrl: process.env.BACKEND_NEW_API_URL,
    geoApiUrl: process.env.GEOAPI_URL,
    poleplanAdminUrl: process.env.POLEPLAN_ADMIN_URL,
    poleplanAdminAuthToken: process.env.POLEPLAN_ADMIN_AUTH_TOKEN,
    isActivePoleplanIntegration: process.env.IS_ACTIVE_POLEPLAN_INTEGRATION
};



// WEBPACK FOOTER //
// ./config/app.js